
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Character } from '@/entities/avatar'
import { getCDNUrl } from '@/utils/cdn'

@Component<CharacterPicker>({})
export default class CharacterPicker extends Vue {
    @Prop(String) public id!: string
    @Prop(String) public label!: string
    @Prop(Object) public value?: Character
    @Prop(Array) public characters?: Character[]
    getCDNUrl = getCDNUrl

    public handleClick(character) {
        this.$emit('change', character)
    }

    public doRefresh() {
        this.$emit('doRefresh')
    }

    public isSelected(character) {
        if (!this.value) {
            return false
        }

        return (
            character.top === this.value.top &&
            character.person === this.value.person
        )
    }
}
